import React from 'react';

import {
    Modal, ModalHeader, ModalBody, ModalFooter,
    Button, Input
} from 'reactstrap';


import moment from 'moment';

import { DOMAINS } from '../../../constants';

class MonthPicker extends React.Component {

    constructor(props) {
        super(props);
        this.wrapperRef = React.createRef();
        this.state = {
            months: [],
            years: [],
            value: null
        }
    }

    setInitialData = () => {
        let setObj = {};
        let currentYear = new Date()?.getFullYear();
        let years = [];
        for (let i = currentYear - 100; i <= currentYear + 20; i++) {
            years.push(i);
        }
        years = years.reverse();
        setObj.years = years;

        let months = [];

        let monthString = [
            'January',
            'February',
            'March',
            'April',
            'May',
            'June',
            'July',
            'August',
            'September',
            'October',
            'November',
            'December'
        ];
        for (let i = 0; i < monthString.length; i++) {
            months.push({
                value: i + 1,
                label: monthString[i]?.translate(this.props.lang)
            })
        }


        setObj.months = months;

        this.setState(setObj);

        this.setValue();

    }
    setValue = () => {
        let date = this.props.date;
        if (!date) {
            date = moment().format('MM/DD/YYYY');
        }
        let month = moment(date).format('MM');
        let year = moment(date).format('YYYY');
        let value = {
            month: parseInt(month),
            year: parseInt(year)
        }
        if (value?.month && value?.year) {
            this.setState({
                value: value
            })
        }

    }



    componentDidMount() {
        this.setInitialData();


    }
    componentDidUpdate(prevProps, prevState) {
        if (prevProps.date !== this.props.date) {
            this.setValue();
        }

    }
    componentWillUnmount() {
    }

    onChangeYear = (year) => {
        let month = this.state.value?.month;
        let date = `${month.toString().padStart(2, '0')}/01/${year}`;
        this.props.onChange(date);
    }
    onChangeMonth = (month) => {
        let year = this.state.value?.year;
        let date = `${month.toString().padStart(2, '0')}/01/${year}`;
        this.props.onChange(date, true);
    }


    render() {
        const date = this.props.date;

        const year = this.state.value?.year;
        const month = this.state.value?.month;

        return (
            <div className='custom-month-picker-wrap'>
                <div className='year-picker-wrap'>
                    <Input
                        type='select'
                        value={year}
                        onChange={(e) => {
                            let value = e.target.value;
                            if (parseInt(value)) {
                                this.onChangeYear(value);
                            }
                        }}
                    >
                        {this.state.years.map((item, index) => {
                            return (
                                <option key={index} value={item}>{item}</option>
                            )
                        })}
                    </Input>
                </div>
                <div className='month-picker-wrap'>
                    {
                        this.state.months.map((item, index) => {
                            return (
                                <div
                                    key={index}
                                    className={`month-item ${item.value === month ? 'active' : ''}`}
                                    onClick={() => {
                                        this.onChangeMonth(item.value);
                                    }}>
                                    {item.label}
                                </div>
                            )
                        })
                    }
                </div>

            </div>


        )
    }
}

export default MonthPicker;